/** @format */

import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { SetDocumentFn } from '../../utils'
import { CustomPageContainer } from 'src/components'
import { _$ } from '@king-design/react'
import Alarm from '../../containers/MonitorGeneral/GeneralAlarm'
import Cost from '../../containers/MonitorGeneral/GeneralCost'
import Resource from '../../containers/MonitorGeneral/GeneralResource'
import ProductDy from '../../containers/MonitorGeneral/GenetalProductDy'
import '../../static/styles/general.styl'

const General: FunctionComponent<any> = ({ className }) => {
  return (
    <div className={className} id="ksc-general">
      <CustomPageContainer
        title={_$('概览')}
        extra={<a onClick={() => SetDocumentFn('28122')}>{_$('quick_start')}</a>}
      >
        <Resource />
        <div className="middle_content">
          <Alarm />
          <ProductDy />
        </div>
        {/* 事件告警概览 */}
        {/* <GeneralAlermTask dataSource={[]} /> */}
        {/* 成本优化 */}
        <Cost />
      </CustomPageContainer>
    </div>
  )
}

export default styled(General)`
  .middle_content {
    display: flex;
    height: 421px;
    margin-top: 20px;
  }
  .custom-page-extra {
    top: 16px;
  }
`
